import { css } from '@/styled-system/css';

export const rowList = css({
  listStyle: 'none',
  padding: 0,
  margin: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: 'tighter',
});

export const row = css({
  display: 'flex',
  alignItems: 'center',
  gap: 'tighter',
  fontSize: 'body',
  color: 'text.neutral',
  lineHeight: 'body',
});

export const rowIcon = css({
  width: '500',
  height: '500',
  flexShrink: 0,
  color: 'text.subtle',
});

export const ctaEmphasis = css({
  textTransform: 'uppercase',
});

// This is an inline mid-sentence text action, not a standalone CTA; keep
// custom link-like styling while using semantic tokens.
export const ctaButton = css({
  appearance: 'none',
  background: 'none',
  border: 'none',
  padding: 0,
  font: 'inherit',
  color: 'text.accent.brand.hero',
  fontWeight: 'bold',
  textDecoration: 'none',
  cursor: 'pointer',
  _hover: {
    textDecoration: 'underline',
  },
  _focusVisible: {
    outlineWidth: 'thick',
    outlineStyle: 'solid',
    outlineColor: 'border.accent.brand.hero',
    outlineOffset: '50',
    borderRadius: 'sm',
  },
});
